const LinkType = {
  none: 0,
  app: 1,
  web: 2,
};

export default LinkType;
